import(/* webpackMode: "eager", webpackExports: ["GoogleLoginButton"] */ "/opt/buildhome/repo/components/auth/GoogleLoginButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/node_modules/next/dist/client/app-dir/link.js");
